import React, { FunctionComponent } from 'react';
import WideContent from 'core/layout/content/wide-content';
import Translate from 'ui/atoms/translate';
import WithAuthenticatedPage from 'core/auth/components/with-authenticated-page';
import { AppType } from 'core/auth/types';
import Section from 'ui/atoms/section';
import Link from 'core/routing/link';
import FriendReferralDetailsGeneralInfo from './general-information';
import LoadingRing from 'ui/atoms/loading-ring';
import ReferralInvestmentsTable from './referral-investments';
import { useFriendReferralDetails } from './hooks';

interface FriendReferralDetailsPageProps {
  referralId: string;
}

const FriendReferralDetailsPage: FunctionComponent<FriendReferralDetailsPageProps> = ({ referralId }) => {
  const { voucher, loading } = useFriendReferralDetails(referralId);

  if (!referralId || !voucher || loading)
    return (
      <WideContent title={<Translate name="issuerFriendReferrals.title" />}>
        <LoadingRing />
      </WideContent>
    );

  return (
    <WideContent
      title={<Translate name="issuerFriendReferrals.details.title" args={[voucher.owningInvestor.investorName]} />}
    >
      <Section spacing="large">
        <Section>
          <WideContent titleSpacing="small">
            <FriendReferralDetailsGeneralInfo
              owningInvestorName={voucher.owningInvestor.investorName}
              voucherCode={voucher.code}
              useTimes={voucher.alreadyUsed}
              active={voucher.active!}
            />
          </WideContent>
        </Section>
        <Section>
          <WideContent
            title={<Translate name="issuerFriendReferrals.connectedInvestments" />}
            ignorePageTitle
            titleSpacing="medium"
          >
            <ReferralInvestmentsTable voucherId={referralId} />
          </WideContent>
        </Section>

        <WideContent>
          <Link icon="arrow-left" to="/dashboard/friendReferrals">
            <Translate as="span" name="issuerFriendReferrals.back" />
          </Link>
        </WideContent>
      </Section>
    </WideContent>
  );
};

export default WithAuthenticatedPage(FriendReferralDetailsPage, AppType.ISSUER);
